import { Navigate } from 'react-router';
import { useTranslate } from '../i18n/useTranslate';
import { useLandingItem } from './landing';

/**
 * Açılış yönlendirmesi (SEOAI-47 incelemesi). Erişilebilir ilk bölüme gider.
 *
 * Hiçbir bölüme erişimi olmayan kullanıcı YÖNLENDİRİLMEZ — nereye gönderilse
 * Forbidden görecekti. Bunun yerine durumu açıklayan bir ekran kalır.
 */
export function LandingRedirect() {
  const t = useTranslate();
  const landing = useLandingItem();

  if (landing) return <Navigate to={landing.to} replace />;

  return (
    <section className="card">
      <h1>{t('landing.noAccessTitle')}</h1>
      <p>{t('landing.noAccessBody')}</p>
    </section>
  );
}
